import {
  Container,
  Box,
  Typography,
  Button,
  Alert,
  LinearProgress,
  TextField,
  // Paper,
  // Avatar,
  // Dialog,
  // DialogContent,
  // TextField,
  // Select,
  // DialogTitle,
  // DialogContentText,
  // DialogActions,
  // MenuItem,
  Snackbar,
  // IconButton,
  // Card,
  // CardMedia,
  CardContent,
  // CardActions,
} from "@mui/material";
// import Edit from "@mui/icons-material/Edit";

// functions
import { useEffect, useState } from "react";
import { useDocument } from "../../hooks/useDocument";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useLogout } from "../../hooks/useLogout";
import { useFirestore } from "../../hooks/useFirestore";
import { increment, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
// import { useNavigate } from "react-router-dom";

// components
// import DropShadowBox from "../../components/DropShadowBox";
// import { PaytmButton } from "../../components/paytm/PaytmButton";
import QRCode from "react-qr-code";
// import QrReader from "react-qr-scanner";
// import { UpdateDisabled } from "@mui/icons-material";
// import Countdown from "react-countdown";

export default function HomePage() {
  const { user: authUser } = useAuthContext();
  const { document: user, error } = useDocument("users", authUser.uid);
  const { logout, logoutIsPending } = useLogout();

  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: { xs: "80vh", sm: "80vh", md: "81.2vh" },
        // marginTop: "10px",
        // marginBottom: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box>
        {(logoutIsPending || (!user && !error)) && (
          <LinearProgress
            sx={{
              position: "absolute",
              top: { xs: "56px", sm: "64px", md: "64px" },
              left: 0,
              right: 0,
              zIndex: 1,
            }}
          />
        )}
        {error && (
          <Alert severity="error">
            {error === "No such document exists"
              ? "Not registered yet, please register now to continue."
              : error}
          </Alert>
        )}

        {error === "No such document exists" && (
          <>
            <Box height={18} />

            <Button
              variant="contained"
              onClick={logout}
              disabled={logoutIsPending}
              sx={{
                margin: "0 auto",
                display: "block",
                // width: "100%",
              }}
            >
              Register now
            </Button>
          </>
        )}

        {user && <Spark user={user} />}
      </Box>
    </Container>
  );
}

function Spark({ user }) {
  const { document: event, error } = useDocument(
    "events",
    "X4q3MoIFbmuSQvTioqK0"
  );

  const [isCoordinator, setIsCoordinator] = useState(false);

  useEffect(() => {
    if (event && event.coordinators.indexOf(user.email) > -1) {
      setIsCoordinator(true);
    }
  }, [event]);

  return (
    <>
      <Box
        component="img"
        alt="Hostel graphics"
        src={require("../../assets/images/home/writing.png").default}
        maxHeight="50vh"
        maxWidth="90vw"
        sx={{
          display: "block",
          margin: "0 auto",
          paddingBottom: "50px",
        }}
      />

      {error && <Alert severity="error">{error}</Alert>}
      {!event && !error && (
        <Typography variant="body1" component="p" color="text.primary">
          Loading...
        </Typography>
      )}
      {isCoordinator && <Coordinator event={event} user={user} />}
      {!isCoordinator && event && <Event event={event} user={user} />}
    </>
  );
}

function Coordinator({}) {
  // dialoge
  // const [open, setOpen] = useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  //qr scan
  // const handleScan = (data) => {
  //   console.log("scan");
  //   console.log(data);
  // };

  // const handleScanError = (error) => {
  //   console.log("scanError");
  //   console.log(error);
  // };

  //save
  // const save = async (data) => {};

  return (
    <>
      <Alert severity="success">
        You are an official coordinator of Spark 2.0
      </Alert>
      {/* <Button
        variant="contained"
        sx={{
          display: "block",
          margin: "0 auto",
          marginTop: "20px",
          marginBottom: "20px",
        }}
        onClick={handleClickOpen}
      >
        Enroll participant
      </Button> */}
    </>
  );
}

// <Dialog open={open} onClose={handleClose}>
//   <DialogTitle>QR enrollment</DialogTitle>
//   <DialogContent>
//     {/* <DialogContentText>
//       Scan QR code for enroll particpant
//     </DialogContentText> */}
//     {/* <QrReader
//       // delay={this.state.delay}
//       // style={previewStyle}
//       onError={handleScanError}
//       onScan={handleScan}
//       // facingMode="rear"
//     /> */}
//   </DialogContent>
//   <DialogActions>
//     <Button
//       onClick={handleClose}
//       sx={{
//         color: "white",
//       }}
//     >
//       Cancel
//     </Button>
//     <Button
//       // disabled={userResponse.isPending || hostelResponse.isPending}
//       onClick={save}
//       sx={{
//         color: "white",
//       }}
//     >
//       Enroll
//     </Button>
//   </DialogActions>
// </Dialog>;

function Event({ event, user }) {
  return (
    <>
      {user.activeEvents && (
        <CardContent
          sx={{
            textAlign: "center",
          }}
        >
          {/* <Typography variant="h6" color="text.primary" fontWeight="500">
            {event.title}
          </Typography>
          <Typography variant="p" color="text.primary">
            {event.subTitle}
          </Typography> */}
          <RegisteredEvent user={user} />
          <Box height="18px" />
          <Typography variant="h5" component="div" color="text.primary">
            Venue: {event.venue}
          </Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            Time: {event.date.from.toDate().toLocaleTimeString()} to{" "}
            {event.date.to.toDate().toLocaleTimeString()}
          </Typography>
          {/* <Typography
            gutterBottom
            variant="h5"
            component="div"
            color="text.primary"
          >
            Registered succesfully
          </Typography> */}
          <Typography variant="p" color="text.primary">
            {event.date.from.toDate().toLocaleDateString()}
          </Typography>
        </CardContent>
      )}
      {!user.activeEvents && <Registration user={user} event={event} />}
    </>
  );
}

function RegisteredEvent({ user }) {
  const { document: registeredEvent, error } = useDocument(
    "events/X4q3MoIFbmuSQvTioqK0/registrations",
    user.email
  );

  return (
    <>
      {error && <Alert severity="error">{error}</Alert>}
      {!registeredEvent && !error && (
        <Typography variant="body1" component="p" color="text.primary">
          Loading...
        </Typography>
      )}
      {registeredEvent && !registeredEvent.isParticipant && (
        <>
          <Alert
            severity="success"
            sx={{
              marginBottom: "1rem",
            }}
          >
            Registered succesfully! Show the QR on the event day for
            participation.
          </Alert>
          <QRCode
            value={registeredEvent.uid}
            bgColor="#FFFFFF"
            fgColor="#eeeee"
            level="Q"
          />
          <Typography variant="body2" sx={{ mt: 1 }} color="text.secondary">
            Registered on:{" "}
            {registeredEvent.registratedOn.toDate().toLocaleDateString()}{" "}
            {registeredEvent.registratedOn.toDate().toLocaleTimeString()}
          </Typography>
        </>
      )}
      {registeredEvent && registeredEvent.isParticipant && (
        <Alert
          severity="success"
          sx={{
            marginBottom: "1rem",
            marginTop: "1rem",
          }}
        >
          Thank you for participation!. You will receive cirtificate of
          participation after the event.
        </Alert>
      )}
    </>
  );
}

function Registration({ event, user }) {
  const [loading, setLoading] = useState(false);

  const { updateDocument: updateUser, response: userResponse } =
    useFirestore("users");
  const { updateDocument: updateEvent, response: eventResponse } =
    useFirestore("events");
  const {
    setDocument: addEventRegistration,
    response: eventRegistrationResponse,
  } = useFirestore(`events/${event.id}/registrations`);
  // const { setDocument: addOrder, response: orderResponse } =
  //   useFirestore("orders");

  //======================================================

  // const save = async ({ message, paymentStatus, checkStatus }) => {
  //   setLoading(true);
  //   console.log("save");
  //   console.log(paymentStatus, checkStatus);
  //   if (paymentStatus && checkStatus) {
  //     if (paymentStatus.STATUS === "TXN_SUCCESS") {
  //       setMessage("Payment Successful!");
  //       updateDb(paymentStatus);
  //     } else {
  //       setError("Payment Failed!");
  //       setLoading(false);
  //     }
  //   } else {
  //     setError(message);
  //     setLoading(false);
  //   }

  //   setSnackbarOpen(true);
  // };

  //===================================================

  const updateDb = async () => {
    if (txnNo.length < 10) {
      setNameError(true);
      return;
    }

    setLoading(true);

    const docRef = doc(db, "events", "X4q3MoIFbmuSQvTioqK0");
    const docSnap = await getDoc(docRef);
    const regId = "00" + (docSnap.data().lastRegId + 1);
    console.log(regId);

    // await addOrder(paymentStatus.ORDERID, {
    //   orderId: paymentStatus.ORDERID,
    //   regId: regId,
    //   eventId: event.id,
    //   userId: user.id,
    //   paytm: paymentStatus,
    // });

    await addEventRegistration(user.email, {
      regId: regId,
      uid: user.uid,
      email: user.email,
      name: user.name,
      phone: user.phone,
      photoURL: user.photoURL,
      txnId: txnNo,
      // orderId: paymentStatus.ORDERID,
      upiTo: "Jasim",
      paymentDate: new Date(),
      eventId: event.id,
      eventTitle: event.title,
      eventSubTitle: event.subTitle,
      eventDate: event.date,
      registratedOn: new Date(),
    });

    await updateEvent(event.id, {
      verifiedRegCount: increment(1),
      lastRegId: docSnap.data().lastRegId + 1,
    });
    await updateUser(user.uid, {
      isMember: true,
      membershipPeriod: {
        from: new Date(),
        to: dateAfterMonth(new Date(), 6),
      },
      activeEvents: [event.id],
    });

    setLoading(false);
    if (
      userResponse.error ||
      eventResponse.error ||
      eventRegistrationResponse.error
      // || orderResponse.error
    ) {
      setError(
        userResponse.error ??
          eventResponse.error ??
          eventRegistrationResponse.error
        //  ?? orderResponse.error
      );
    }

    setSnackbarOpen(true);
  };

  //====================================================

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();
  const dateAfterMonth = (input, months) => {
    const date = new Date(input);
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    date.setDate(
      Math.min(
        input.getDate(),
        getDaysInMonth(date.getFullYear(), date.getMonth() + 1)
      )
    );
    return date;
  };

  // Renderer callback with condition
  // const renderer = ({ hours, minutes, seconds, completed }) => {
  //   if (completed) {
  //     // Render a completed state
  //     return (
  //       <>
  //         <Typography
  //           gutterBottom
  //           variant="h5"
  //           component="div"
  //           color="text.primary"
  //         >
  //           Pay {event.fee}₹
  //         </Typography>
  //         <Typography sx={{ mb: 1.5 }} color="text.secondary" variant="body2">
  //           Read and accept our{" "}
  //           <a
  //             href="/return-refund-policy"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               navigate("/return-refund-policy");
  //             }}
  //           >
  //             policy.
  //           </a>
  //         </Typography>
  //         <PaytmButton
  //           orderId={`spark1_${new Date().getTime()}`}
  //           amount={449}
  //           name={user.name}
  //           uid={user.uid}
  //           email={user.email}
  //           phone={user.phone}
  //           callback={save}
  //           isTestMode={false}
  //         />
  //       </>
  //     );
  //   } else {
  //     // Render a countdown
  //     return (
  //       <>
  //         <Typography
  //           gutterBottom
  //           variant="h6"
  //           component="div"
  //           color="text.primary"
  //         >
  //           Coming soon!
  //         </Typography>
  //         <Typography
  //           // gutterBottom
  //           variant="h1"
  //           component="div"
  //           color="text.primary"
  //           fontWeight="fontWeightBold"
  //         >
  //           {hours}:{minutes}:{seconds}
  //         </Typography>
  //         <Typography variant="body2" component="div" color="text.primary">
  //           Get complete refund for the first 20 payments.
  //         </Typography>
  //       </>
  //     );
  //   }
  // };

  //====================================================

  // const navigate = useNavigate();

  const [txnNo, setTxnNo] = useState("");
  const [nameError, setNameError] = useState(false);

  return (
    <>
      <CardContent
        sx={{
          textAlign: "center",
        }}
      >
        {loading && (
          <Alert
            severity="info"
            sx={{
              marginBottom: "1rem",
            }}
          >
            Updating.. Please wait. Don't click on refresh or back button.
          </Alert>
        )}
        {/* <Countdown
          date={Date.now() + 5000}
          // date={1654795800000}
          renderer={renderer}
          onComplete={() => console.log("onComplete")}
        /> */}
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          color="text.primary"
        >
          Pay {event.fee}₹ to
        </Typography>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          color="text.primary"
        >
          UPI phone: 7558865377
        </Typography>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          color="text.primary"
        >
          UPI ID: pajasim5-1@okhdfcbank
        </Typography>
        <TextField
          required
          id="txnId"
          label="UPI Transaction ID"
          type="text"
          value={txnNo}
          error={nameError}
          onChange={(e) => setTxnNo(e.target.value)}
        />
        {/* <Typography sx={{ mb: 1.5 }} color="text.secondary" variant="body2">
          Read and accept our{" "}
          <a
            href="/return-refund-policy"
            onClick={(e) => {
              e.preventDefault();
              navigate("/return-refund-policy");
            }}
          >
            policy.
          </a>
        </Typography> */}
        <Box height="10px" />
        <Button
          variant="contained"
          onClick={updateDb}
          disabled={loading}
          sx={{
            backgroundColor: "white",
            color: "black",
            "&:hover": {
              backgroundColor: "black",
              color: "white",
            },
            margin: "0 auto",
            display: "block",
            // width: "100%",
          }}
        >
          {loading ? "Loading.." : "Submit"}
        </Button>
        <Box height="10px" />
        {!loading &
        (
          <Alert
            severity="info"
            sx={{
              marginBottom: "1rem",
            }}
          >
            Pay 449₹ on above UPI no/id and copy paste the transaction ID and
            click submit to complete the registration.
          </Alert>
        )}
      </CardContent>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={error ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {error ? error : message ? message : "Completed!"}
        </Alert>
      </Snackbar>
    </>
  );
}

// function HostelViewer({ user }) {
//   const [userHostel, setUserHostel] = useState({});
//   const [isUserDeclined, setIsUserDeclined] = useState(false);
//   const [isPendingRequest, setIsPendingRequest] = useState(false);

//   // dialoge
//   const [open, setOpen] = useState(false);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   useEffect(() => {
//     for (var id in user.hostels) {
//       if (user.hostels[id].isInmate && !user.hostels[id].isVerified) {
//         setIsPendingRequest(true);
//         setUserHostel(user.hostels[id]);
//       } else if (user.hostels[id].isInmate === false) {
//         setIsUserDeclined(true);
//         setUserHostel(user.hostels[id]);
//       } else if (user.hostels[id].isVerified) {
//         setIsPendingRequest(false);
//         setIsUserDeclined(false);
//         setUserHostel({ id: id, ...user.hostels[id] });
//       }
//     }
//   }, [user]);

//   const { document: hostel, error } = useDocument("hostels", userHostel.id);

//   return (
//     <>
//       {isPendingRequest && (
//         <Alert severity="info">
//           Pending approval. Wait for admin verification.
//         </Alert>
//       )}
//       {isUserDeclined && (
//         <Alert severity="warning">
//           {
//             "Admin declined your registration. Reregister again with correct info or register to diferent hostel."
//           }
//         </Alert>
//       )}
//       {userHostel.id && !hostel && (
//         <Typography variant="h5" fontWeight="500" textAlign="center">
//           Loading...
//         </Typography>
//       )}
//       {error && error !== "No id" && <Alert severity="error">{error}</Alert>}
//       {!isUserDeclined && !isPendingRequest && userHostel.id && hostel && (
//         //todo: add error handling
//         <>
//           <Paper
//             sx={{
//               padding: "10px",
//               width: "100%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "left",
//               borderRadius: "100px",
//               boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
//             }}
//           >
//             <Avatar alt={hostel.name} src={hostel.logoImg} />
//             <Typography
//               variant="h5"
//               fontWeight="500"
//               textAlign="center"
//               sx={{
//                 marginLeft: "10px",
//                 marginRight: "10px",
//               }}
//             >
//               {/* Nila Ladies Hostel */}
//               {hostel.name}
//             </Typography>
//           </Paper>

//           <FoodPreferenceDialoge
//             open={open}
//             handleClose={handleClose}
//             foodPreferenceIn={userHostel.foodPreference}
//             userId={user.id}
//             hostelId={hostel.id}
//           />

//           {userHostel.foodPreference && (
//             <DropShadowBox padding="8px 8px 8px 20px">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   flexWrap: "wrap",
//                   justifyContent: "center",
//                 }}
//               >
//                 <Typography variant="body" fontWeight="500">
//                   Food preference: {userHostel.foodPreference.name}
//                 </Typography>
//                 <Box sx={{ height: "10px" }} />
//                 <IconButton
//                   variant="contained"
//                   onClick={handleClickOpen}
//                   sx={{
//                     margin: "0 auto",
//                     display: "block",
//                     // width: "100%",
//                   }}
//                 >
//                   <Edit />
//                 </IconButton>
//               </div>
//             </DropShadowBox>
//           )}

//           {!userHostel.foodPreference && (
//             <DropShadowBox>
//               <Typography variant="body" fontWeight="500" textAlign="center">
//                 Food preference not selected yet.
//               </Typography>
//               <Box sx={{ height: "10px" }} />
//               <Button
//                 variant="contained"
//                 onClick={handleClickOpen}
//                 sx={{
//                   margin: "0 auto",
//                   display: "block",
//                   // width: "100%",
//                 }}
//               >
//                 Set food preference
//               </Button>
//             </DropShadowBox>
//           )}
//           {userHostel.foodPreference && (
//             <DropShadowBox>
//               <FoodMenu
//                 menu={hostel.foodMenu}
//                 foodPreference={userHostel.foodPreference}
//               />
//             </DropShadowBox>
//           )}
//           <Box
//             sx={{
//               marginTop: "10px",
//               padding: "20px",
//               alignItems: "center",
//               borderRadius: "20px",
//               boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
//             }}
//           >
//             <Typography variant="body" fontWeight="500" textAlign="center">
//               More features coming soon.😀👉
//             </Typography>
//           </Box>
//           <Box sx={{ height: "20px" }} />
//         </>
//       )}
//     </>
//   );
// }

// const foodPreferences = [
//   {
//     id: "non-veg",
//     name: "Non-Vegetarian",
//   },
//   {
//     id: "veg",
//     name: "Pure Vegetarian",
//   },
//   {
//     id: "non-egg",
//     name: "Without Egg",
//   },
//   {
//     id: "non-fish",
//     name: "Without Fish",
//   },
//   {
//     id: "non-chicken",
//     name: "Without Chicken",
//   },
// ];

// function FoodPreferenceDialoge({
//   open,
//   handleClose,
//   foodPreferenceIn,
//   userId,
//   hostelId,
// }) {
//   const [foodPreference, setFoodPreference] = useState(
//     foodPreferenceIn
//       ? foodPreferences.find(
//           (foodPreference) => foodPreference.id === foodPreferenceIn.id
//         )
//       : foodPreferences[0]
//   );

//   const { updateDocument: updateUser, response: userResponse } =
//     useFirestore("users");
//   const { updateDocument: updateHostel, response: hostelResponse } =
//     useFirestore("hostels");

//   const save = async () => {
//     handleClose();
//     if (!foodPreferenceIn) {
//       await updateUser(userId, {
//         [`hostels.${hostelId}.foodPreference`]: foodPreference,
//       });
//       await updateHostel(hostelId, {
//         [`foodPreferences.${foodPreference.id}`]: increment(1),
//       });
//     } else if (foodPreferenceIn.id !== foodPreference.id) {
//       await updateUser(userId, {
//         [`hostels.${hostelId}.foodPreference`]: foodPreference,
//       });
//       await updateHostel(hostelId, {
//         [`foodPreferences.${foodPreference.id}`]: increment(1),
//         [`foodPreferences.${foodPreferenceIn.id}`]: increment(-1),
//       });
//     } else {
//       return;
//     }

//     if (userResponse.error || hostelResponse.error) {
//       setError(userResponse.error ?? hostelResponse.error);
//     }
//     setSnackbarOpen(true);
//   };

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [error, setError] = useState(null);

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }

//     setSnackbarOpen(false);
//   };

//   return (
//     <div>
//       <Dialog open={open} onClose={handleClose}>
//         <DialogTitle>Food preference</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Select your food preference from below list.
//           </DialogContentText>
//           <TextField
//             id="foodPreference"
//             variant="filled"
//             select
//             label="Select"
//             value={foodPreference}
//             onChange={(e) => setFoodPreference(e.target.value)}
//             // helperText="Please select your currency"
//             sx={{ width: "100%", marginTop: "10px" }}
//           >
//             {foodPreferences.map((option) => (
//               <MenuItem key={option.id} value={option}>
//                 {option.name}
//               </MenuItem>
//             ))}
//           </TextField>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose}>Cancel</Button>
//           <Button
//             // disabled={userResponse.isPending || hostelResponse.isPending}
//             onClick={save}
//           >
//             Save
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={handleSnackbarClose}
//       >
//         <Alert
//           onClose={handleSnackbarClose}
//           severity={error ? "error" : "success"}
//           sx={{ width: "100%" }}
//         >
//           {error ? error : "Successfully updated!"}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// }

// const weekDays = [
//   "Sunday",
//   "Monday",
//   "Tuesday",
//   "Wednesday",
//   "Thursday",
//   "Friday",
//   "Saturday",
// ];
// const times = ["Breakfast", "Lunch", "Evening", "Dinner"];
// const getTimeOfDay = (hour) => {
//   if (hour < 10) {
//     return "Breakfast";
//   } else if (hour < 15) {
//     return "Lunch";
//   } else if (hour < 18) {
//     return "Evening";
//   } else {
//     return "Dinner";
//   }
// };
// function FoodMenu({ menu, foodPreference }) {
//   const [day, setDay] = useState(weekDays[new Date().getDay()]);
//   const [foodMenu, setFoodMenu] = useState(menu[day]);
//   const [time, setTime] = useState(getTimeOfDay(new Date().getHours()));

//   useEffect(() => {
//     if (foodPreference.id === "non-veg")
//       setFoodMenu(menu[day][time]["non-veg"]);
//     else setFoodMenu(menu[day][time]["veg"]);
//   }, [day, time, menu, foodPreference]);

//   return (
//     <div
//       style={{
//         maxWidth: "500px",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           flexWrap: "wrap",
//           justifyContent: "space-between",
//         }}
//       >
//         <Select
//           id="daysSelector"
//           variant="standard"
//           disableUnderline
//           value={day}
//           onChange={(e) => setDay(e.target.value)}
//         >
//           {weekDays.map((option) => (
//             <MenuItem key={option} value={option}>
//               <Typography variant="body" fontWeight="500" textAlign="center">
//                 {option}
//               </Typography>
//             </MenuItem>
//           ))}
//         </Select>
//         <Typography
//           variant="h6"
//           textAlign="center"
//           sx={{
//             marginLeft: "10px",
//             marginRight: "10px",
//           }}
//         >
//           Menu
//         </Typography>
//         <Select
//           id="timesSelector"
//           variant="standard"
//           disableUnderline
//           value={time}
//           onChange={(e) => setTime(e.target.value)}
//         >
//           {times.map((option) => (
//             <MenuItem key={option} value={option}>
//               <Typography variant="body" fontWeight="500" textAlign="center">
//                 {option}
//               </Typography>
//             </MenuItem>
//           ))}
//         </Select>
//       </div>
//       <>
//         <CardMedia
//           component="img"
//           height="100%"
//           image={foodMenu["img"]}
//           alt="Paella dish"
//           sx={{
//             maxHeight: "300px",
//             borderRadius: "10px",
//             marginTop: "10px",
//           }}
//         />
//         <CardContent
//           sx={{
//             "&:last-child": {
//               paddingBottom: "0px",
//             },
//           }}
//         >
//           <Typography
//             gutterBottom
//             variant="h6"
//             component="div"
//             fontWeight="500"
//           >
//             {foodMenu["name"]}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {foodPreference.id === "non-veg" ? "Non-veg" : "Veg"} menu
//           </Typography>
//         </CardContent>
//       </>
//     </div>
//   );
// }
